import { Invoice } from '@/models/accounting/Invoice'
import { Document } from '@/models/Document'
import { createModelFromResponse } from '@/utils/model'
import axios from 'axios'

export interface GenerateInvoiceData {
	attachedDocuments: Array<Document> | null
	invoiceNumber: number | null
	invoiceDate: string | null
	hasInvoiceNumber: boolean
	selectedLanguage: string | null
	combinedAttachments: boolean
}

export interface GenerateInvoiceResult {
	response: any
	pdfDocument: Document
	documentId: string
}

export async function generateInvoicePdf(
	item: Invoice,
	receivedData: GenerateInvoiceData | null
): Promise<GenerateInvoiceResult> {
	const requestBody = {
		data: {
			attributes: {
				invoiceDate: receivedData?.invoiceDate ?? null,
				...(receivedData?.hasInvoiceNumber
					? {}
					: {
							invoiceNumber: receivedData?.invoiceNumber ?? null
					  }),
				combinedAttachments: receivedData?.combinedAttachments ?? false
			}
		}
	}

	const response = await item.doCallbackWithLanguage(
		async (httpClient) => {
			return httpClient.post(`${item.getJsonApiType()}/${item.getApiId()}/generate`, requestBody)
		},
		receivedData?.selectedLanguage
	)

	const responseDocument = response.data.included?.find((r: any) => r.type === 'documents')
	if (!responseDocument) {
		throw new Error('No document in generate response')
	}

	const pdfDocument = createModelFromResponse(Document, { data: responseDocument }) as Document

	await axios.patch(`${pdfDocument.getModelUrl()}/attachments`, {
		data: (receivedData?.attachedDocuments ?? []).map((e) => e.toResourceLinkObject())
	})

	return {
		response,
		pdfDocument,
		documentId: responseDocument.id as string
	}
}
